import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { CouponQueryFilter } from '../../shared/types';
import { CITRIN_GET_COUPONS_BY_OPERATORID, GetCouponsByOperatorIdRequest, GetCouponsByOperatorIdResponse } from '..';

export const useGetCouponsByOperatorIdQuery = (
    request: CouponQueryFilter,
    operatorId: string,
    debounceTime?: number
) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: CouponQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetCouponsByOperatorIdResponse, GetCouponsByOperatorIdRequest>(
        CITRIN_GET_COUPONS_BY_OPERATORID,
        {
            variables: { operatorId, request: internalRequest },
            fetchPolicy: 'cache-and-network',
            // onCompleted: (data) => console.log('[MGT] Users', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getCouponsByOperatorId,
        data: data?.CITRIN_MGT_getCouponsByOperatorId ?? [],
    };
};
